module.exports = __webpack_public_path__ + "img/B76E5E_7F3A2F_EE938C_F8A5A1-256px.2fedac7f.png";